export const orgTypeOptions = [
  "Startup",
  "SME",
  "Large Enterprise",
  "NGO / Non-Profit",
  "Government",
  "Individual",
];

export const timelineOptions = [
  "Immediately",
  "Within 1 month",
  "1 – 3 months",
  "3 – 6 months",
  "6+ months",
];
